import React from "react";
import { useState,useEffect } from "react";
import Iconos from "../iconos/iconos";

import { getValue } from '@syncfusion/ej2-base';
import { GridComponent, ColumnsDirective, ColumnDirective, Filter, Page, Sort, Resize, Inject,  } from '@syncfusion/ej2-react-grids';
import { URL, URLSOCKET, GETREFERENCESRESUME} from "../paths";
import { getUserID, getUserEntityIsEmployee,getIntUserEntityTypeId, getintUserEntityId } from "../datainfo/dto";
import { ToastContainer } from 'react-toastify'; 
import Loader from "../loader/loader"; 
import { Mensaje } from "../Message/message";
import './../../css/bootstrap.min.css';
import './../../css/material3.css' 
import { fetchData } from "../../hooks/fetch/const_fetch";
import { ValidaItemMenu,ValidaIsModal,validSesion } from "../datainfo/dto";
import CerrarSesion from "../datainfo/del_dto";
//import {ModalRechazarPdf}
import 'react-tabs/style/react-tabs.css';
import io from 'socket.io-client';
import Cookies  from 'universal-cookie';
import { Menu,Dash } from "../menu";
import "./pool_resumen.css"

{/*import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';*/}
 

const PoolResumen = () => { 
    const d = new Date();
    const fecha_actual = (((d.getFullYear())+"-"+(d.getMonth()<10?("0"+(d.getMonth()+1)):d.getMonth()+1)+"-"+(d.getDate())));
           
    //const [fechainicio,setFechaInicio] =useState(new Date());
    let [fechainicio,setFechaInicio] = useState(fecha_actual);
    //const [fechafin,setFechaFin] =useState(new Date());
    let [fechafin,setFechaFin] = useState(fecha_actual);
    const [validafechainicio,setValidaFechaInicio] = useState("");
    const [validafechafin,setValidaFechaFin] = useState("");

    const [numpendientes,setNumPendientes] = useState(0);
    const [numterminados,setNumTerminados] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [primera, setPrimera] = useState(true);

    const [buscar,setBuscar] = useState("");
    const [validabuscar,setValidaBuscar] = useState("");

    const [dtoresumen,setDtoResumen] = useState([]);

    if(!(validSesion())){ 
        CerrarSesion();
    } 


    useEffect(()=>{ 
        const socket = io(URLSOCKET, {autoConnect:true,transports: [ 'websocket' ]});
        // Puedes agregar lógica adicional aquí, como suscribirte a eventos
        socket.on("connect", () => {
           //console.log("Socket conectado ID: "+socket.id);
        });
 
        if(getUserEntityIsEmployee() === 1){
            socket.on("ref", (msg) => { 
               // console.log(msg); 
                if(msg.code !== 0){
                    return;
                }
                
                if(msg.intMode === 4 || msg.intMode === 6 || msg.intMode === 5){
                    ConsultarResumen(false);
                } 
            }); 
        } 
        //Cierra la conexión del socket cuando el componente se desmonta
        return () => {
          socket.disconnect();
         // console.log("Socket desconetado.")
        }; 
     
      }, []);
   
    useEffect(()=>{
        if(primera){ 
            fechainicio = (fecha_actual);
            fechafin    = (fecha_actual);
            ConsultarResumen();
        } 
     
    }, []);
     
    if(!ValidaItemMenu("resumen")){
        CerrarSesion();
        return;
    }
 
    const handleBuscar = (text)=>{
       // setValidaBuscar('is-valid');
        setBuscar(text);
        if (grid) {
            grid.search(text);
        }
    }
 
    const ConsultarResumen = async(mostrar_cortinilla)=>{
        setDtoResumen([]);
        
        setNumPendientes("-");
        setNumTerminados("-");

       /* alert(fechainicio )
        alert(fechafin)*/

        if(fechainicio === "" || fechafin === ""){
            setValidaFechaInicio(" is-invalid");
            Mensaje("Debe asignar fechas de inicio valida.","error","top-center",3500);
            return;
        }   
        if( fechafin === ""){
            setValidaFechaFin(" is-invalid");
            Mensaje("Debe asignar fecha de termino valida.","error","top-center",3500);
            return;
        }   
        
        
        /*const auxfechainicio = new Date(fechainicio.replaceAll('-','/'));
        const auxfechafin = new Date(fechafin.replaceAll('-','/'));
     
        alert(fechainicio)
        alert(fechafin)*/
        
        
        if(fechafin < fechainicio){
            setValidaFechaFin(" is-invalid");
            setValidaFechaInicio(" is-invalid");
            Mensaje("La fecha de finalización no puede ser menor a la de inicio","error","top-center",4500);
            return;
        }else{
            setValidaFechaFin(" is-valid ");
            setValidaFechaInicio(" is-valid ");
        }
        /*alert( fechainicio.getFullYear() +"-"+
            ( fechainicio.getMonth()<=9? "0"+(fechainicio.getMonth()+1):fechainicio.getMonth()+1 )                                 
            +"-"+          
            ( fechainicio.getDate()<=9? "0"+(fechainicio.getDate()):fechainicio.getDate() )    
        )*/                                                                                                                                                                         //(d.getDate()<10?"0"+d.getDate():d.getDate())
        
        /*const fi =(auxfechainicio.getFullYear()+( auxfechainicio.getMonth()<=9? "0"+(auxfechainicio.getMonth()+1):auxfechainicio.getMonth()+1)+( (auxfechainicio.getDate())<10? "0"+(auxfechainicio.getDate()):auxfechainicio.getDate() )); 
        const ff =(auxfechafin.getFullYear()+( auxfechafin.getMonth()<=9? "0"+(auxfechafin.getMonth()+1):auxfechafin.getMonth()+1)+( (auxfechafin.getDate())<10? "0"+(auxfechafin.getDate()):auxfechafin.getDate() ) );
        alert(fechainicio.replaceAll('-',''))
        alert(fechafin.replaceAll('-',''))*/
        try { 
            if(mostrar_cortinilla){
                setIsLoading(true);  
            }
            setDtoResumen([]);
            
                const url = URL+GETREFERENCESRESUME; 
                const params = {
                    "intUserId":getUserID(),
                    "dtmStartDate":fechainicio.replaceAll('-',''),
                    "dtmEndDate":fechafin.replaceAll('-',''),
                }  
                //console.log(params)
                setPrimera(false);
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
                if(resultado.code === 0){  
                   // console.log(resultado);
                    setNumPendientes(resultado.resumeCards[0].PEND);
                    setNumTerminados(resultado.resumeCards[0].TER);
                    setDtoResumen(resultado.resume);
                    //Mensaje(resultado.msg, "success", "top-center",3500); 
                    setIsLoading(false);
                }else{
                    Mensaje(resultado.msg, "error", "top-center",3500); 
                    setIsLoading(false); 
                } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud - ConsultarDocumentosUsuario(), ERROR: "+error.messaje ,"error","top-center");
        }
    }

    let grid;
   
    const rowDataBound = (args) => {
        if (args.row) {
            if ( parseInt(getValue('intCusDocId', args.data)) < 10) {
                args.row.classList.add('asignado');
                //args.row.classList.add('bg-primary');
            }
            else if (getValue('intCusDocId', args.data) < 20) {
                args.row.classList.add('bg-warning');
            }
            else {
                //args.row.classList.add('bg-danger');
                args.row.classList.add('bg-white');
            }
        }
    }

    const HaldleFecha=(evt)=>{
        setDtoResumen([]);
        
        if(evt.target.id === "dtefechainicio"){
            //setFechaInicio(new Date(evt.target.value))
            setFechaInicio(evt.target.value);
            setValidaFechaInicio("");
        }else if(evt.target.id === "dtefechafin"){
            //setFechaFin(new Date(evt.target.value))
            setFechaFin(evt.target.value)
            setValidaFechaInicio("");
        }else{
            return;
        }        
    }

    const ColumnStatus = (props) => {
        return (     
        
            <label className="fw-bold">
                {
                    props.strStatus === "CAP"?
                    <span className="text-primary"> 
                    <Iconos icono={props.strStatus}  width={"25"} height={"25"}  fill="#0d6efd" />
                    <span className="px-2">CAPTURADO</span>
                    </span>:
                    props.strStatus === "ON-VALID"? 
                        <span className="text-warning"> 
                            <Iconos icono={props.strStatus}  width={"25"} height={"25"} fill="#ffb936"/>
                            <span className="px-2">EN VALIDACIÓN</span>
                        </span>:
                        props.strStatus === "REJ"?
                            <span className="text-danger" title={props.strReason}>
                                <Iconos icono={props.strStatus}  width={"25"} height={"25"} fill="#dc3545"/>
                                <span className="px-2">RECHAZADA</span>
                            </span>:
                                    props.strStatus === "TER"?
                                    <span className="text-success"> 
                                        <Iconos icono={"CERRADO"}  width={"25"} height={"25"} fill="#198754"/>
                                        <span className="px-2">TERMINADO</span>
                                    </span>:
                                        props.strStatus === "CAN"?
                                        <span className="text-black"> 
                                            <Iconos icono={"CANCELADO"}  width={"25"} height={"25"} fill="#000"/>
                                            <span className="px-2">CANCELADO</span>
                                        </span>:<></>
                }
            </label>    
            
        ) 
    }

    const cellStatus = ColumnStatus;

    return(
        <div className="main">
            <Menu />
            { isLoading? <Loader /> : <></> } 
            <ToastContainer  style={{width:'50%'}}/>
            <Dash>
                <div >  
                    <p className="h4">RESUMEN</p>
                    <hr />
                        <div id="cards" className="">
                            <div className="row row-cols-1 row-cols-md-3 g-3">
                                <div className="col text-center ">
                                    <div className="card mb-1" >
                                        <div className="card-header h5 text-bg-primary p-1">
                                            <h5 className="card-title fw-bold ">TERMINADOS</h5>
                                        </div>
                                        <div className="card-body p-1"> 
                                            <p className="card-text fs-4 fw-bold">{numterminados}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col text-center ">
                                    <div className="card mb-1" >
                                        <div className="card-header text-bg-warning p-1">
                                            <h5 className="card-title fw-bold">PENDIENTE</h5>
                                        </div>
                                        <div className="card-body p-1"> 
                                            <p className="card-text fs-4 fw-bold">{numpendientes}</p>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>

                        <div className="row py-1">
                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                <label htmlFor="dtefechainicio" className="">FECHA INICIO</label>
                           
                                {/*<DatePickerComponent id="dtefechainicio"  value={fechainicio} format={"yyyy-MM-dd"}  onChange={(evt)=>{HaldleFecha(evt)}}></DatePickerComponent>*/}
                                <input id="dtefechainicio" type="date" className={`form-control  form-control-sm ${validafechainicio}`}  value={fechainicio}  onChange={(evt)=>{HaldleFecha(evt)}} />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                <label htmlFor="dtefechafin">FECHA TERMINO</label>
                            
                                {/*<DatePickerComponent id="dtefechafin"    value={fechafin}    format={"yyyy-MM-dd"} onKeyPress={()=>{return;}} onChange={(evt)=>{HaldleFecha(evt)}} > </DatePickerComponent>*/}
                                <input id="dtefechafin" type="date" className={`form-control  form-control-sm ${validafechafin}`}  value={fechafin}   onChange={(evt)=>{HaldleFecha(evt)}} />
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"> 
                                <button className="btn btn-sm text-bg-primary h-100 w-100" onClick={ConsultarResumen}>
                                    <span className="mx-1">BUSCAR</span>
                                    <Iconos icono={"BUSCAR"}  width={"20"} height={"20"} fill="#fff"/>
                                </button>
                            </div>
                        </div>

                        <div className="">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 my-0 py-0">
                                <div className="input-group input-group-sm p-0 my-1">
                                    <input type="text" className={`form-control form-control-xs ${validabuscar}`} value={buscar}  onChange={(evt)=>{handleBuscar(evt.target.value)}} />
                                    <span className="input-group-text btn btn-secondary" id="inputGroup-sizing-sm" >
                                        <Iconos icono={"BUSCAR"}  width={"20"} height={"20"} fill="#fff"/>
                                    </span>
                                </div>
                            </div>   
                        </div>    
                        <div className="" style={{ overflow:"scroll"}}>
                            <GridComponent  
                                dataSource={dtoresumen} 
                                ref={g => grid = g}
                                dataStateChange={dtoresumen} 
                                allowPaging={true} 
                                allowResizing={true} 
                                rowHeight={25} 
                                height='auto' 
                                //allowFiltering={true}  
                                allowSorting = {true} 
                                pageSettings={{pageSize:15, pageCount:15,  pageSizes: true }}
                                rowDataBound={rowDataBound} >
                                <ColumnsDirective >  
                                    <ColumnDirective field={'strUser'} Type={"ColumnType.String"} width='70' headerText="NOMBRE USUARIO" textAlign="center"/>         
                                    <ColumnDirective field={'strStatus'} template={cellStatus} Type={"ColumnType.String"}   width='45' headerText="ESTATUS" textAlign="center"/>
                                    <ColumnDirective field={'total'} Type={"ColumnType.String"} width='60' headerText="TOTAL"  textAlign="center" />
                                </ColumnsDirective>  
                                <Inject services={[Page,Filter,Sort,Resize ]} />
                            </GridComponent>
                        </div>
                </div>
            </Dash>
        
        </div>
        
    );
}
 
export default PoolResumen;